import React from 'react';
import { Link } from 'react-router-dom'; // If you use React Router for navigation
import './Navbar.css'; // Import the CSS file for styling

const Navbar = () => {
  return (
    <nav className="navbar">
      <div className="navbar-left">
        <Link to="/" >chatPDF</Link>
      </div>
      <div className="navbar-right">
        <Link to="/login" className="navbar-button">Login</Link> {/* Link to login page */}
        <Link to="/signup" className="navbar-button">Signup</Link> {/* Link to signup page */}
      </div>
    </nav>
  );
};

export default Navbar;
